<app-snackbar></app-snackbar>

<div class="flex gap-M pad-XL-XL-0 w-100 border-box">
	<app-diagram-breadcrumb class="w-100"></app-diagram-breadcrumb>

	<div class="flex-align-center filter-bar bkg-white b-radius-9" style="padding: 3px;border: 0.5px solid #DCDCE9">
		<app-text-button type="default" color="primary" style="width: 43px; height: 43px;"
						 panelClass="h-100-imp pad-0-imp"
						 (click)="refresh()"
						 [disabled]="_loading"
						 [loading]="_refreshing">
			<div class="flex-center">
				<img src="assets/icons/refresh-cw-01.svg" height="18" alt=""/>
			</div>
		</app-text-button>
	</div>
</div>

<div class="mt-xl ml-xl mr-xl mb-xl canvas" #canvasContainer style="height: calc(100% - 210px); overflow: hidden">
	<canvas #canvas></canvas>

	<div *ngIf="isNotData" class="nodata flex f-d-col flex-align-center">
		<img src="assets/illustrations/diagram-nodata.svg" width="175" class="primary illustration">
		<div class="nodata-title text-center">
			{{ 'page.diagram.capacity.nodata-title' | translate}}
		</div>
		<div class="nodata-subtitle text-center w-60">
			{{ 'page.diagram.capacity.nodata-subtitle' | translate}}
		</div>
		<div class="nodata-box text-center" (click)="onAddGroup()" >
			<span class="nodata-button">{{ 'page.diagram.capacity.nodata-button' | translate}}</span>
		</div>
	</div>

	<!-- Scrollbar horizontale -->
	<div *ngIf="shouldShowHorizontalScrollbar"
		 class="horizontal-scrollbar"
		 [ngStyle]="horizontalScrollbarStyles">
		<div class="horizontal-thumb"
			 [ngStyle]="horizontalThumbStyles"></div>
	</div>

	<!-- Scrollbar verticale -->
	<div *ngIf="shouldShowVerticalScrollbar"
		 class="vertical-scrollbar"
		 [ngStyle]="verticalScrollbarStyles">
		<div class="vertical-thumb"
			 [ngStyle]="verticalThumbStyles"></div>
	</div>
</div>

<div *ngIf="isData" (mousedown)="$event.stopPropagation()" class="diagram-zoom">
	<div class="diagram-zoom-button" (click)="onRecenter();" matRipple><img src="assets/icons/center.svg" width="18" class="filter-primary"></div>
	<div class="diagram-zoom-button" (click)="onZoomOut();" matRipple><img src="assets/icons/minus.svg" width="24" class="filter-primary"></div>
	<div class="diagram-zoom-info" *ngIf="getZoomLevel() >= 0">{{ getZoomLevel() | number: '1.0-0'}}%</div>
	<div class="diagram-zoom-info" *ngIf="getZoomLevel() < 0">- %</div>
	<div class="diagram-zoom-button" (click)="onZoomIn();" matRipple><img src="assets/icons/add.svg" width="14" class="filter-primary"></div>
</div>

<!--Pop up capacity GROUP-->
<div class="popup-group dots-menu"
	 [style.display]="popupState.isGroupVisible ? 'block' : 'none'"
	 [style.left.px]="popupState.groupX"
	 [style.top.px]="popupState.groupY">
	<div class="popup-capacity-group flex-column gap-XS">
		<div class="capacity-title-group flex-align-center gap-XS b-radius-6 c-p dots-menu-action-button" (click)="onAddCapacity()">
			<img class="icon" ngSrc="assets/icons/functional-capacities/menu-icons/plus.svg" alt="Add a capacity to a group"
				 height="14" width="14"/>
			<span class="text font-M fw-500 white">{{ 'page.diagram.capacity.capacity-menu.add-group' | translate}}</span>
		</div>
		<div class="capacity-title-group flex-align-center gap-XS b-radius-6 c-p dots-menu-action-button" (click)="onEditGroup()">
			<img class="icon" ngSrc="assets/icons/functional-capacities/menu-icons/edit-05.svg" alt="Edit a capacity" height="14"
				 width="14"/>
			<span class="text font-M fw-500 white">{{ 'page.diagram.capacity.capacity-menu.modif-group' | translate}}</span>
		</div>
		<div class="capacity-title-group flex-align-center gap-XS b-radius-6 c-p dots-menu-action-button" (click)="onDeleteGroup()">
			<img class="icon" ngSrc="assets/icons/functional-capacities/menu-icons/trash-03.svg" alt="Delete a capacity"
				 height="14" width="14"/>
			<span class="text font-M fw-500 white">{{ 'page.diagram.capacity.capacity-menu.del-group' | translate}}</span>
		</div>
	</div>
</div>

<!--Pop up capacity CHILD-->
<div class="popup dots-menu"
	 [style.display]="popupState.isCapacityVisible ? 'block' : 'none'"
	 [style.left.px]="popupState.capacityX"
	 [style.top.px]="popupState.capacityY">
	<div class="popup-capacity flex-column gap-XS">
		<div class="capacity-title flex-align-center gap-XS b-radius-6 c-p dots-menu-action-button" (click)="onAddApplication()">
			<img class="icon" ngSrc="assets/icons/functional-capacities/menu-icons/plus.svg" alt="Edit a capacity" height="14"
				 width="14"/>
			<span class="text font-M fw-500 white">{{ 'page.diagram.capacity.capacity-menu.add-app' | translate}}</span>
		</div>
		<div class="capacity-title flex-align-center gap-XS b-radius-6 c-p dots-menu-action-button" (click)="onEditCapacity()">
			<img class="icon" ngSrc="assets/icons/functional-capacities/menu-icons/edit-05.svg" alt="Add a capacity to a group"
				 height="14" width="14"/>
			<span class="text font-M fw-500 white">{{ 'page.diagram.capacity.capacity-menu.modif-capacity' | translate}}</span>
		</div>
		<div class="capacity-title flex-align-center gap-XS b-radius-6 c-p dots-menu-action-button" (click)="onDeleteCapacity()">
			<img class="icon" ngSrc="assets/icons/functional-capacities/menu-icons/trash-03.svg" alt="Delete a capacity"
				 height="14" width="14"/>
			<span class="text font-M fw-500 white">{{ 'page.diagram.capacity.capacity-menu.del-capacity' | translate}}</span>
		</div>
	</div>
</div>

<!--ToolTip-->
<div class="popup"
	 [style.display]="tooltipState.isVisible ? 'block' : 'none'"
	 [style.left.px]="tooltipState.x"
	 [style.top.px]="tooltipState.y">
	<div class="tooltip flex-column gap-XS tooltip-container">
		<div [innerHTML]="tooltipState.fullSizeName">
		</div>
		<div class="tooltip-pointer"
			 [class]="'tooltip-' + tooltipState.position"
			 [style.left]="tooltipState.position === 'bottom' || tooltipState.position === 'top' ? 'calc(50% - 5px)' : tooltipState.position === 'right' ? '-5px' : ''"
			 [style.right]="tooltipState.position === 'left' ? '-5px' : ''"
			 [style.top]="tooltipState.position === 'left' || tooltipState.position === 'right' ? 'calc(50% - 5px)' : tooltipState.position === 'bottom' ? '-5px' : ''"
			 [style.bottom]="tooltipState.position === 'top' ? '-5px' : ''">
		</div>
	</div>
</div>
